import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "left-block-wrapper d-flex flex-column justify-content-center" }
const _hoisted_2 = { class: "logo d-flex justify-content-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "logo-headline" }, "Scrapx", -1)
const _hoisted_4 = { class: "auth-wrapper container" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "title-wrapper d-flex"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h4", null, "Create your scrapx account", -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "auth-form-wrapper" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "account-type d-flex justify-content-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "text" }, "Don’t have an account?", -1)

import { ref } from "vue";
import { computed } from "vue";
import LeftSide from "./LeftSide.vue";
import UserForm from "@/views/auth/UserForm.vue";
import LogoIcon from "@/views/components/LogoIcon.vue";
import { store } from "@/store";


export default /*#__PURE__*/_defineComponent({
  __name: 'LeftSideBlock',
  setup(__props) {

const getUserSession = computed(() => store.getters.getUserSession);
const getUser = computed(() => store.getters.getUser);
const isSignUp = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_authenticator = _resolveComponent("authenticator")!
  const _component_authenticator_sign_up_form_fields = _resolveComponent("authenticator-sign-up-form-fields")!
  const _component_amplify_check_box = _resolveComponent("amplify-check-box")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(LogoIcon)
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      (!_unref(getUserSession))
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (isSignUp.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_8))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_9, [
              (isSignUp.value)
                ? (_openBlock(), _createBlock(_component_authenticator, {
                    key: 0,
                    services: _ctx.services,
                    "social-providers": ['google'],
                    "username-alias": "email",
                    "initial-state": "signUp",
                    "login-mechanisms": ['email']
                  }, null, 8, ["services"]))
                : (_openBlock(), _createBlock(_component_authenticator, {
                    key: 1,
                    class: "signin",
                    services: _ctx.services,
                    "social-providers": ['google'],
                    "username-alias": "email",
                    "login-mechanisms": ['email'],
                    "initial-state": "signIn",
                    "hide-sign-up": true
                  }, {
                    "sign-up-fields": _withCtx(() => [
                      _createVNode(_component_authenticator_sign_up_form_fields),
                      _createVNode(_component_amplify_check_box, {
                        errorMessage: _ctx.validationErrors.acknowledgement
                      }, null, 8, ["errorMessage"])
                    ]),
                    default: _withCtx(({ user, signOut }) => [
                      _createElementVNode("h1", null, "Hello " + _toDisplayString(user.username) + "!", 1),
                      _createElementVNode("button", { onClick: signOut }, "Sign Out", 8, _hoisted_10)
                    ]),
                    _: 1
                  }, 8, ["services"])),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createTextVNode("  "),
                _createElementVNode("span", {
                  class: "account-type-mode",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (isSignUp.value = !isSignUp.value))
                }, _toDisplayString(isSignUp.value ? "Sign in" : "Sign up"), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})